module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Basic Details","field":{"name":"Project name"},"action":{"update":"Save settings"},"alert":{"success":"Project settings saved!"}}}')
  delete Component.options._Ctor
}
